import { AssetApi } from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const assetApi = new AssetApi(config);

export const assetRequestInit = { credentials: 'include' as const };
